module.exports = __webpack_public_path__ + "static/media/2 4 Ordkjedetest-Feil-ost-par-vask-jakt.65d2a6aa.mp3";